<template>
    <div class="box">
        <div class="field">
            <p class="title">User</p>
        </div>
        <hr style="margin-left:25px;margin-right:25px;"/>

        <table>
            <tr>
                <td style="border-right: solid 1px #d0d0d0;">
                    <b class="textlabel">Username</b>
                </td>
                <td>
                    <div v-if="edit==false">
                        <p class="textfield">{{username}}</p>
                    </div>
                    <div v-else>
                        <input id="username" class="textfield" type="username" v-model="username"></input>
                    </div>
                </td>
            </tr>
            <tr v-if="edit==true">
                <td style="border-right: solid 1px #d0d0d0;">
                    <b class="textlabel">Password</b>
                </td>
                <td>
                    <div class="textfield">
                        <button type="button" v-on:click="change_password()">Change Password</button>
                    </div>
                </td>
            </tr>
            <tr>
                <td style="border-right: solid 1px #d0d0d0;">
                    <b class="textlabel">User ID</b>
                </td>
                <td>
                    <div>
                        <p class="textfield">{{userid}}</p>
                    </div>
                </td>
            </tr>
            <tr>
                <td style="border-right: solid 1px #d0d0d0;">
                    <b class="textlabel">Session Expire</b>
                </td>
                <td>
                    <div v-if="edit==false">
                        <p class="textfield">{{sessionend}}</p>
                    </div>
                    <div v-else>
                        <b class="textfield">Remember me</b>
                        <input class="textfield" style="width:40px;" id="remember" type="checkbox" v-model="remember" v-on:click="change_session()"></input>
                    </div>
                </td>
            </tr>
        </table>

        <div class="field">
            <button type="button" v-on:click="edit_change()">
                <div v-if="edit==false">Edit</div>
                <div v-else>Save</div>
            </button>
        </div>
    </div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
	data() {
		return {
            edit:false,
			username: '',
            userid: '',
            sessionend: '',
            remember:false,
		}
	},
    async created () {
        this.getCookies()
    },
	methods: {
        getCookies(){
            this.username=api.getCookie("user");
            this.userid=api.getCookie("userid");
            this.sessionend=api.getCookie("sessionexpire");

            this.remember = (this.sessionend!="Session")
        },
        edit_change(){
            this.edit=!this.edit;
            this.getCookies();
        },
        change_session(){
            if(!this.remember){
                var now = new Date();
                var expire_time = now.getTime() + 14*2000*36000;
                now.setTime(expire_time);
                document.cookie="session="+api.getCookie("session")+";expires="+now.toGMTString()+";";
                document.cookie="user="+api.getCookie("user")+";expires="+now.toGMTString()+";";
                document.cookie="userid="+api.getCookie("userid")+";expires="+now.toGMTString()+";";
                document.cookie="perms="+api.getCookie("perms")+";expires="+now.toGMTString()+";";

                var currentDate = new Date();
                var date = currentDate.getFullYear()+"-"+('00'+(currentDate.getMonth()+1)).slice(-2)+"-"+('00'+currentDate.getDate()).slice(-2);
                var hour = ('00'+currentDate.getHours()).slice(-2)
                var minute = ('00'+currentDate.getMinutes()).slice(-2)
                var seconds = ('00'+currentDate.getSeconds()).slice(-2)
                var currentDateString = date+' '+hour+':'+minute+':'+seconds

                document.cookie="sessionexpire="+currentDateString+";";
            }else{
                document.cookie="session="+api.getCookie("session")+";";
                document.cookie="user="+api.getCookie("user")+";";
                document.cookie="userid="+api.getCookie("userid")+";";
                document.cookie="perms="+api.getCookie("perms")+";";
                document.cookie="sessionexpire=Session;";
            }
        },
        change_password(){
            router.push('/0203');
        }
	}
}
</script>

<style scoped>
.box{
    margin-right: 25%;
    margin-left: 25%;
    margin-top: 55px;
    border: 3px solid #35495E;
    border-radius: 20px;
}

.field{
    padding:10px;
    text-align:center;
}

.textlabel{
    float:right;
    white-space:nowrap;
    color:#35495E;
}

.textfield{
    float:left;
    margin:0px;
}

.title{
    font-size:30px;
    font-weight:bold;
    color:#35495E;
}

.smalltext{
    font-size: 12px;
	color: #888888;
}

button.link {
    background:none;
    border:none;
    color:#0066dd;
    text-decoration: underline;
}

table {
    table-layout:auto;
    margin:auto;
    width:75%;
    border: none;
}
td {
    padding-left:20px;
    padding-right:20px;
    text-align:center;
    border: none;
    width:25%;
}
</style>



// WEBPACK FOOTER //
// src/components/file/Account.vue